import { useTranslations } from "use-intl";
import { Feature, isFeatureEnabled } from "../lib/utils/featureFlags";
import { formatCurrency } from "../lib/utils/currency";
import { usePaymentContext } from "../lib/context/PaymentContext";
import {
  includeBnplFee,
  calculateMonthlyInstallment,
} from "../lib/utils/bnpl-fee";

export type Props = {
  totalPrice: number;
};

export function PaymentOptions({ totalPrice }: Props) {
  const t = useTranslations();
  const { maxAvailableInstallments, isEligible } = usePaymentContext();
  const isBnplFeatureEnabled =
    isFeatureEnabled(Feature.Bnpl) && Boolean(isEligible);

  const includedBnplFee = includeBnplFee(totalPrice);
  const monthlyPayment = calculateMonthlyInstallment(
    includedBnplFee,
    maxAvailableInstallments,
  );

  return (
    <div className="mb-4 flex h-full flex-col gap-4">
      {isBnplFeatureEnabled && (
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-text-primary">
            {t("payment.payLaterPerMonth")}
          </span>
          <span dir="ltr" className="text-md font-semibold">
            {formatCurrency(monthlyPayment)}
          </span>
        </div>
      )}
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-text-primary">
          {t("payment.standard")}
        </span>

        <span dir="ltr" className="text-md font-semibold">
          {formatCurrency(totalPrice)}
        </span>
      </div>
    </div>
  );
}
